const messageButtonStyle = {
    width: '100%',
    marginTop: '16px',
    height: '30px',
    backgroundColor: 'black',
    color: 'white',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 400,
    borderRadius: '90px',
    _hover: {
        backgroundColor: 'gray.800'
    },
    _disabled: {
        backgroundColor: 'gray.40',
        color: 'gray.650',
        border: 'none !important',
        opacity: 1,
        cursor: 'not-allowed',
        _hover: {
            backgroundColor: 'gray.40'
        }
    }
}

const GiftWrapBox = {
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            border: '1px solid',
            borderColor: 'gray.400',
            borderRadius: '10px',
            padding: '20px',
            backgroundColor: 'white',
            sx: {
                '.chakra-checkbox__label': {
                    marginLeft: 0
                }
            }
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
        },
        checkboxLabel: {
            fontFamily: 'body',
            fontWeight: 400,
            fontSize: '14px',
            color: 'black.100',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            marginLeft: '24px',
            lineHeight: '24px'
        },
        giftIcon: {
            width: '18px',
            height: '18px',
            flexShrink: 0
        },
        body: {
            display: 'flex',
            flexDirection: 'row',
            gap: '15px',
            alignItems: 'flex-start'
        },
        giftImage: {
            width: '100px',
            height: 'auto',
            flexShrink: 0,
            borderRadius: '4px'
        },
        description: {
            fontFamily: 'body',
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '22px',
            color: 'black.100'
        },
        disclaimer: {
            fontFamily: 'body',
            fontWeight: 300,
            fontSize: '14px',
            lineHeight: '20px',
            color: 'black.100',
            marginTop: '12px'
        },
        textarea: {
            fontFamily: 'body',
            fontSize: '16px',
            fontWeight: 300,
            color: 'black.100',
            border: '1px solid',
            borderColor: 'gray.600',
            borderRadius: '4px',
            padding: '12px',
            minHeight: '80px',
            resize: 'vertical',
            marginTop: '16px',
            _placeholder: {
                color: 'black.100'
            },
            _focus: {
                borderColor: 'gray.600',
                boxShadow: 'none',
                outline: 'none',
                background: 'none'
            },
            _invalid: {
                border: '1px solid #B14848',
                boxShadow: 'none',
                outline: 'none',
                _hover: {
                    border: '1px solid #B14848',
                    boxShadow: 'none',
                    outline: 'none'
                }
            },
            _hover: {
                borderColor: 'gray.600',
                boxShadow: 'none',
                outline: 'none',
                background: 'none'
            }
        },
        charCounter: {
            fontFamily: 'body',
            fontSize: '13px',
            fontWeight: 300,
            color: 'gray.600',
            marginTop: '4px'
        },
        ecoNote: {
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            fontFamily: 'body',
            fontSize: '13px',
            fontWeight: 300,
            color: 'black',
            marginTop: '12px',
            padding: '15px',
            backgroundColor: 'green.150',
            borderRadius: '0 0 3px 3px'
        },
        ecoIcon: {
            height: '23px',
            flexShrink: 0
        },
        savedMessage: {
            fontFamily: 'body',
            fontWeight: 300,
            fontSize: '14px',
            lineHeight: '22px',
            color: 'black.100',
            marginTop: '0',
            marginBottom: '8px',
            paddingLeft: '0',
            paddingRight: '0'
        },
        saveButton: {
            ...messageButtonStyle
        },
        editButton: {
            ...messageButtonStyle,
            width: 'fit-content'
        },
        statusText: {
            fontFamily: 'body',
            fontWeight: 300,
            fontSize: '13px',
            color: 'gray.600',
            marginTop: '10px'
        },
        errorMessage: {
            fontFamily: 'body',
            fontSize: '13px',
            fontWeight: 400,
            color: 'red.400',
            marginTop: '4px'
        },
        collapseContent: {
            overflow: 'hidden'
        }
    }
}

export default GiftWrapBox
